export function runWhenIdle(task: () => void, timeout = 2000): void {
  if (typeof window === "undefined") {
    task();
    return;
  }

  const w = window as any;
  if (typeof w.requestIdleCallback === "function") {
    w.requestIdleCallback(() => task(), { timeout });
    return;
  }

  setTimeout(task, 0);
}

export function runAfterUserInteraction(task: () => void, timeout = 5000): void {
  if (typeof window === "undefined") {
    task();
    return;
  }

  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    cleanup();
    task();
  };

  const cleanup = () => {
    window.removeEventListener("pointerdown", finish, true);
    window.removeEventListener("keydown", finish, true);
    window.removeEventListener("touchstart", finish, true);
  };

  window.addEventListener("pointerdown", finish, { capture: true, passive: true });
  window.addEventListener("keydown", finish, { capture: true, passive: true });
  window.addEventListener("touchstart", finish, { capture: true, passive: true });

  setTimeout(finish, timeout);
}
